<template>
  <div class="container">
    <h1><i class="fa fa-file-video-o"></i> films needing attention</h1>

    <div v-for="film in filmlist" :key="film._id">
      <router-link :to="`edit-film/${film._id}`">{{film.name}}</router-link>
    </div>

  </div>
</template>


<script>
import axios from "axios";
import analytics from "@/analytics";

export default {

  name: "AdminMacrodataRefinement",

  data() {
    return {
      filmlist: []
    }
  },

  async created() {
    this.filmlist = [];

    axios.get(`/api/admin/films-needing-attention`)
        .then((response) => {
          this.filmlist = response.data;
        })
        .catch((err) => {
          analytics.notifyBugsnagOfError(err);
        });
  },

  methods: {

  }


}
</script>


<style scoped>

a {
  text-decoration: inherit;

  &:visited {
    color: slategrey;
  }
}

</style>